import type { ProfileDetails } from "./reference-data";

export function profileDraftFingerprint(name: string, bio: string, details: ProfileDetails): string {
  return JSON.stringify([
    name,
    bio,
    details.locationId,
    details.purpose,
    details.occupation,
    details.heightCm,
    details.station,
    details.socialUsername,
    details.hideAge ?? false,
    details.hideOnline ?? false,
  ]);
}
